import { useContext, useEffect } from "react"
import Context from "../Context"
import ROSLIB from "roslib"

export const mapFeedInfo = (context) => {

  if (window.ros) {
    let map

    if (context.selectedRobot.ROS === 'ROS2') {
      map = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/map",
        messageType: "nav_msgs/msg/OccupancyGrid"
      })
    } else {
      map = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/map",
        messageType: "nav_msgs/OccupancyGrid"
      })
    }

    map.subscribe((message) => {
      //console.log(message, context)
      context.actions.setMapFeedFull(message.info)
    })

    return map
  }
}

// remote control
export const moveRobot = (payload, ROS) => {
  let topic

  // console.log("saga: moving robot to ", payload.axes[0], payload.axes[1])
  if (ROS === 'ROS2') {
    topic = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/remote/joy",
      messageType: "sensor_msgs/msg/Joy",
    })
  } else {
    topic = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/remote/joy",
      messageType: "sensor_msgs/Joy",
    })
  }

  var comm = new ROSLIB.Message(payload)
  topic.publish(comm)
}

// send task to robot
export const sendTaskToRobot = (payload, ROS) => {
  let info

  if (ROS === 'ROS2') {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/currentTask_hack",
      messageType: "custom_msgs/msg/Task",
      qos: {
        history: 'keep_last',
        depth: 1,
        reliability: 'reliable',
        durability: 'volatile'
      }
    })
  } else {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/currentTask_hack",
      messageType: "custom_msgs/Task",
    })
  }

  console.log(info, payload)
  var comm = new ROSLIB.Message(payload)

  info.publish(comm)
}


export const sendMissionToRobot = (payload, ROS) => {

  // rostopic pub -1 /wgo/fms/currentTask custom_msgs/Mission "{id: 'Mission name', command: 'PickP', value: 'PointRack', level: '1.0', type: ''}"

  let info


  info = new ROSLIB.Topic({
    ros: window.ros && window.ros,
    name: "/wgo/fms/currentTask",
    messageType: "custom_msgs/Mission",
  })


  console.log(info, payload)
  var comm = new ROSLIB.Message(payload)

  info.publish(comm)
}


// cancel actions
export const cancelActions = (payload, ROS) => {
  let info

  if (ROS === 'ROS2') {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/cancelTask",
      messageType: "custom_msgs/msg/Cancel",
    })
  } else {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/cancelTask",
      messageType: "custom_msgs/Cancel",
    })
  }

  console.log("sending cancellation to robot (saga)", payload)
  var comm = new ROSLIB.Message(payload)
  info.publish(comm)
}

export const releaseLifter = (payload) => {
  var info = new ROSLIB.Topic({
    ros: window.ros && window.ros,
    name: "/Outputs",
    messageType: "std_msgs/UInt32",
  })

  console.log("sending releaseMagnet to robot (saga)", payload)
  var comm = new ROSLIB.Message(payload)
  info.publish(comm)
}

// cancel last
export const cancelLast = (payload, ROS) => {
  let info

  if (ROS === 'ROS2') {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/cancelLast",
      messageType: "std_msgs/msg/Bool",
    })
  } else {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/cancelLast",
      messageType: "std_msgs/Bool",
    })
  }

  console.log("sending cancellation to robot (saga)", payload)
  var comm = new ROSLIB.Message(payload)
  info.publish(comm)
}

// send journey info
export const sendJourney = (payload) => {

  var info = new ROSLIB.Topic({
    ros: window.ros && window.ros,
    name: "/wgo/fms/currentJourney",
    messageType: "std_msgs/Int8",
  })

  console.log("sending journey to robot:", payload)
  var comm = new ROSLIB.Message(payload)
  info.publish(comm)
}

// on-off devices actions
export const sendNavInfo = (payload, ROS) => {
  let info

  if (ROS === 'ROS2') {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/navInfo",
      messageType: "custom_msgs/msg/NavInfo",
    })
  } else {
    info = new ROSLIB.Topic({
      ros: window.ros && window.ros,
      name: "/wgo/fms/navInfo",
      messageType: "custom_msgs/NavInfo",
    })
  }

  console.log("sending nav info to robot", payload)
  var comm = new ROSLIB.Message(payload)
  info.publish(comm)
}

// end of mission
export const watchEndOfMission = (context) => {
  // setInterval(() => {
  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/task_manager/TaskFeedback",
        messageType: "custom_msgs/msg/TaskFeedback",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/task_manager/TaskFeedback",
        messageType: "custom_msgs/TaskFeedback",
      })
    }

    // console.log("starting to watch end of mission")

    status.subscribe((message) => {
      context.actions.setEndOfMission(message)
    })

    return status
  }
}


export const watchJoystickFeedBack = (context) => {
  // setInterval(() => {

  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/teleop_remote/cmd_vel_desired",
        messageType: "geometry_msgs/msg/Twist",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/teleop_remote/cmd_vel_desired",
        messageType: "geometry_msgs/Twist",
      })
    }

    status.subscribe((message) => {
      //Removed zero velocity in robot
      if (message.angular.z === 0) {
        moveRobot({ axes: [0, 0, 0, 0, 0, 0], buttons: [0, 0, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0, 0] }, context.selectedRobot.ROS)
      }
    })

    return status
  }
}



export const watchRobotPosition = (context) => {

  // setInterval(() => {

  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/current_position",
        messageType: "geometry_msgs/msg/Pose",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/current_position",
        messageType: "geometry_msgs/Pose",
      })
    }

    status.subscribe((message) => {
      context.actions.setRobotPosition(message)
    })

    return status
  }
  //}, 1000)
}


/*
export const watchMapping = (context) => {
  //  setInterval(() => {
  // const status = new ROSLIB.Topic({
  //   ros: window.ros && window.ros,
  //   name: "/wgo/task_manager/TaskFeedback",
  //   messageType: "custom_msgs/msg/TaskFeedback",
  // })
  // status.subscribe((message) => {

  //   if (message?.status === "executing" && message?.actions[0]?.name === "MappingMachine") {
  //     context.actions.setMappingStatus(true)
  //   } else {
  //     context.actions.setMappingStatus(false)
  //   }

  // })

}*/


export const watchBattery = (context) => {

  if (window.ros) {
    let battery

    if (context.selectedRobot.ROS === 'ROS2') {
      battery = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/battery_indicator/battery_status",
        messageType: "sensor_msgs/msg/BatteryState",
      })
    } else {
      battery = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/battery_indicator/battery_status",
        messageType: "sensor_msgs/BatteryState",
      })
    }

    battery.subscribe(function (message) {
      context.actions.setBattery(message.percentage)

    })
  } else {
    context.actions.setBattery(-1)
  }


}

export const watchDiagnostic = (context) => {

  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/alive_signal/system_diagnostic",
        messageType: "std_msgs/msg/String",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/alive_signal/system_diagnostic",
        messageType: "std_msgs/String",
      })
    }

    status.subscribe((message) => {

      //  status.subscribe((message) => {
      if (context.diagnostic?.data === message?.data || context.diagnostic === "")
        context.actions.setDiagnosticTime(new Date())
      context.actions.setDiagnostic(message)
    })
  }
}

export const watchForkHeight = (context) => {
  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/fork_indicator/fork_height",
        messageType: "std_msgs/msg/Float32",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/fork_indicator/fork_height",
        messageType: "std_msgs/Float32",
      })
    }

    status.subscribe((message) => {
      context.actions.setForkHeight(message.data)
    })
  }
}

export const watchLoad = (context) => {
  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/fork_setting/fork_has_load",
        messageType: "std_msgs/msg/Bool",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/fork_setting/fork_has_load",
        messageType: "std_msgs/Bool",
      })
    }

    status.subscribe((message) => {
      context.actions.setLoad(message.data)
    })
  }
}

export const watchPalletHeight = (context) => {
  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/load_height_detection/height",
        messageType: "std_msgs/msg/Float32",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/wgo/load_height_detection/height",
        messageType: "std_msgs/Float32",
      })
    }

    status.subscribe((message) => {
      context.actions.setPalletHeight(message.data)
    })
  }
}

export const watchPalletWeight = (context) => {
  if (window.ros) {
    let status

    if (context.selectedRobot.ROS === 'ROS2') {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/LoadCellWeight",
        messageType: "std_msgs/msg/UInt16MultiArray",
      })
    } else {
      status = new ROSLIB.Topic({
        ros: window.ros && window.ros,
        name: "/LoadCellWeight",
        messageType: "std_msgs/UInt16MultiArray",
      })
    }

    status.subscribe((message) => {
      context.actions.setPalletWeight(message.data[1])
    })
  }
}

// Function to send commands and receive return via ROS topic
export const sendCommandAndListen = (context, commandTopic = "/wgo/command", resultTopic = "/wgo/command_result") => {
  // Publisher para enviar comandos
  const commandPublisher = new ROSLIB.Topic({
    ros: window.ros,
    name: commandTopic,
    messageType: "std_msgs/String"
  });

  // Subscribe to receive feedback
  const resultSubscriber = new ROSLIB.Topic({
    ros: window.ros,
    name: resultTopic,
    messageType: "std_msgs/String"
  });

  // Subscribe to the result and save it in the context
  resultSubscriber.subscribe((message) => {
    if (context.actions && context.actions.setCommandResult) {
      context.actions.setCommandResult(message.data);
    }
  });

  // Function to send command (string)
  const sendCommand = (cmd) => {
    const msg = new ROSLIB.Message({ data: cmd });
    commandPublisher.publish(msg);
  };

  // Return function to send command (can be used in component)
  return sendCommand;
};

// =====================================================
// FUNCTIONS FOR RVIZ AND POSE ESTIMATE COMPONENTS
// =====================================================

// Subscribe to robot position
export const subscribeToRobotPosition = (context, callback) => {
  if (!window.ros || !window.rosConnected) return null;

  const positionTopic = new ROSLIB.Topic({
    ros: window.ros,
    name: '/wgo/current_position',
    messageType: context.selectedRobot?.ROS === 'ROS2' ? 'geometry_msgs/msg/Pose' : 'geometry_msgs/Pose'
  });

  positionTopic.subscribe((message) => {
    if (callback) callback(message);
  });

  return positionTopic;
};

// Subscribe to occupancy map
export const subscribeToOccupancyMap = (context, callback) => {
  if (!window.ros || !window.rosConnected) return null;

  const mapTopic = new ROSLIB.Topic({
    ros: window.ros,
    name: '/map',
    messageType: context.selectedRobot?.ROS === 'ROS2' ? 'nav_msgs/msg/OccupancyGrid' : 'nav_msgs/OccupancyGrid'
  });

  mapTopic.subscribe((message) => {
    if (callback) callback(message);
  });

  return mapTopic;
};

// Subscribe to laser data
export const subscribeToLaserData = (context, laserName, topic, callback) => {
  if (!window.ros || !window.rosConnected) return null;

  const laserTopic = new ROSLIB.Topic({
    ros: window.ros,
    name: topic,
    messageType: context.selectedRobot?.ROS === 'ROS2' ? 'sensor_msgs/msg/LaserScan' : 'sensor_msgs/LaserScan'
  });

  laserTopic.subscribe((message) => {
    if (callback) callback(laserName, message);
  });

  return laserTopic;
};

// Create publisher for pose estimate
export const createPoseEstimatePublisher = () => {
  if (!window.ros || !window.rosConnected) return null;

  return new ROSLIB.Topic({
    ros: window.ros,
    name: '/initialpose',
    messageType: 'geometry_msgs/PoseWithCovarianceStamped'
  });
};

// Publish pose estimate
export const publishPoseEstimate = (publisher, poseData) => {
  if (!publisher) return;

  const poseWithCovariance = new ROSLIB.Message({
    header: {
      stamp: { secs: Math.floor(Date.now() / 1000), nsecs: 0 },
      frame_id: 'map'
    },
    pose: {
      pose: poseData.pose,
      covariance: poseData.covariance || [
        0.25, 0.0, 0.0, 0.0, 0.0, 0.0,
        0.0, 0.25, 0.0, 0.0, 0.0, 0.0,
        0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
        0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
        0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
        0.0, 0.0, 0.0, 0.0, 0.0, 0.06853891945200942
      ]
    }
  });

  publisher.publish(poseWithCovariance);
};

// Measure connection latency
export const measureConnectionLatency = async (robotIp) => {
  if (!robotIp) return null;

  const startTime = performance.now();
  
  try {
    // First try HTTP
    const response = await fetch(`http://${robotIp}:80`, {
      method: 'HEAD',
      cache: 'no-cache',
      signal: AbortSignal.timeout(5000)
    });
    
    if (response.ok) {
      return Math.round(performance.now() - startTime);
    }
  } catch (error) {
    // If HTTP fails, try WebSocket
    try {
      const ws = new WebSocket(`ws://${robotIp}:9090`);
      
      return new Promise((resolve) => {
        const timeout = setTimeout(() => {
          ws.close();
          resolve(null);
        }, 5000);
        
        ws.onopen = () => {
          clearTimeout(timeout);
          ws.close();
          resolve(Math.round(performance.now() - startTime));
        };
        
        ws.onerror = () => {
          clearTimeout(timeout);
          resolve(null);
        };
      });
    } catch (wsError) {
      return null;
    }
  }
  
  return null;
};

// Function to disconnect all subscribers
export const unsubscribeFromTopic = (topic) => {
  if (topic && typeof topic.unsubscribe === 'function') {
    topic.unsubscribe();
  }
};

// Function to disconnect multiple subscribers
export const unsubscribeFromTopics = (topics) => {
  if (Array.isArray(topics)) {
    topics.forEach(topic => unsubscribeFromTopic(topic));
  } else if (typeof topics === 'object') {
    Object.values(topics).forEach(topic => unsubscribeFromTopic(topic));
  }
};

// fire default topic listeners
export default function ROSFunctions() {

  const context = useContext(Context)

  useEffect(() => {



    // person

    const watchNewPerson = () => {
      // setInterval(() => {
      let person

      if (context.selectedRobot.ROS === 'ROS2') {
        person = new ROSLIB.Topic({
          ros: window.ros && window.ros,
          name: "/wgo/user_interaction/person_detection",
          messageType: "custom_msgs/msg/Interaction",
        })
      } else {
        person = new ROSLIB.Topic({
          ros: window.ros && window.ros,
          name: "/wgo/user_interaction/person_detection",
          messageType: "custom_msgs/Interaction",
        })
      }

      //console.log("starting to watch new person")

      person.subscribe((message) => {
        context.actions.setFoundPeople(message.new_person ? true : false)
        // person.unsubscribe()
      })
      // }, 1000)
    }

    const watchStatusRobot = () => {
      setInterval(() => {
        let status

        if (context.selectedRobot.ROS === 'ROS2') {
          status = new ROSLIB.Topic({
            ros: window.ros && window.ros,
            name: "/wgo/task_manager/TaskFeedback",
            messageType: "custom_msgs/msg/TaskFeedback",
          })
        } else {
          status = new ROSLIB.Topic({
            ros: window.ros && window.ros,
            name: "/wgo/task_manager/TaskFeedback",
            messageType: "custom_msgs/TaskFeedback",
          })
        }
        if (window.ros) {
          status.subscribe((message) => {
            // console.log("feedback message", message)

            if (message?.status === "executing" && message?.actions[0]?.status === "blockedStatus") {
              context.actions.setRobotStatus(true)
              context.actions.setModalState({ ...context.modalState, disconnect: true })
            }
          })
        }
        status.unsubscribe()
      }, 10000)

    }

    const watchRobotPosition = () => {

      // setInterval(() => {

      if (window.ros) {
        let status

        if (context.selectedRobot.ROS === 'ROS2') {
          status = new ROSLIB.Topic({
            ros: window.ros && window.ros,
            name: "/wgo/current_position",
            messageType: "geometry_msgs/msg/Pose",
          })
        } else {
          status = new ROSLIB.Topic({
            ros: window.ros && window.ros,
            name: "/wgo/current_position",
            messageType: "geometry_msgs/Pose",
          })
        }

        status.subscribe((message) => {
          context.actions.setRobotPosition(message)

        })
      }

    }

    // diagnostic
    // const watchDiagnostic = () => {
    //   setInterval(() => {
    //     const status = new ROSLIB.Topic({
    //       ros: window.ros && window.ros,
    //       name: "/wgo/diagnostic/msg",
    //       messageType: "std_msgs/msg/String",
    //     })

    //     status.subscribe((message) => {
    //       status.unsubscribe()
    //     })
    //   }, 2000)
    // }


    // end of missions
    const watchEndOfMissionOld = () => {
      // setInterval(() => {
      let status

      if (context.selectedRobot.ROS === 'ROS2') {
        status = new ROSLIB.Topic({
          ros: window.ros && window.ros,
          name: "/wgo/task_manager/TaskFeedback",
          messageType: "custom_msgs/msg/TaskFeedback",
        })
      } else {
        status = new ROSLIB.Topic({
          ros: window.ros && window.ros,
          name: "/wgo/task_manager/TaskFeedback",
          messageType: "custom_msgs/TaskFeedback",
        })
      }

      // console.log("starting to watch end of mission")

      status.subscribe((message) => {
        //  console.log("Task Robot Status ", message.status)

        context.actions.setEndOfMission(message)

      })
      status.unsubscribe()
      // }, 1991)
    }

    // update desinfection speeds
    const updateDesinfectionSpeeds = () => {
      setInterval(() => {
        let info

        if (context.selectedRobot.ROS === 'ROS2') {
          info = new ROSLIB.Topic({
            ros: window.ros && window.ros,
            name: "/wgo/uvrobot/desinfect_vel",
            messageType: "custom_msgs/msg/DesinfectVel",
          })
        } else {
          info = new ROSLIB.Topic({
            ros: window.ros && window.ros,
            name: "/wgo/uvrobot/desinfect_vel",
            messageType: "custom_msgs/DesinfectVel",
          })
        }

        // console.log("sending desinfect vel to robot (saga)", window.settings ? window.settings : {})
        var comm = new ROSLIB.Message(window.settings ? window.settings : {})
        info.publish(comm)
      }, 1000)
    }

    const wathcRecharge = (context) => {

      setInterval(() => {

        if (window.ros) {
          const status = new ROSLIB.Topic({
            ros: window.ros && window.ros,
            name: "/wgo/charge_controller/status",
            messageType: "std_msgs/Bool",
          })

          status.subscribe((message) => {
            context.actions.setRecharge(message)
          })
          status.unsubscribe()

          return status
        }
      }, 2000)
    }

  }, [])

  return null
}
